import React, { useEffect, useState } from 'react'
import MenuIcon from '@mui/icons-material/Menu';
import axios from "axios"
import dayjs from "dayjs"
import { v4 as uuidv4 } from "uuid"
import { WithContext as ReactTags, SEPARATORS } from "react-tag-input";
import Spinner from 'react-bootstrap/Spinner';
// import Pagination from 'react-bootstrap/Pagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { ConfigProvider, Pagination } from "antd";
import { usePapaParse } from 'react-papaparse';
import { useCSVDownloader } from 'react-papaparse';
import { Flex, Progress } from "antd";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CustomSpinner from '../components/CustomSpinner';
import InputBase from '@mui/material/InputBase'
import IconButton from '@mui/material/IconButton'
import SearchIcon from '@mui/icons-material/Search'
function StudentMaster({ serverURL, user, setShowSideOverlay, socket, logToUse, setLogToUse }) {

    const [currentPageNumber, setCurrentPageNumber] = useState(1)
    const [globleSearchValues, setGlobleSearchValues] = useState([])
    const [loadingEntries, setLoadingEntries] = useState(true);
    const [entriesLimit, setEntriesLimit] = useState(100)
    const [skipEntries, setSkipEntries] = useState(0)

    const [totalEntriesCount, setTotalEntriesCount] = useState(0)

    const [counter, setCounter] = useState(null)
    const [totalStudents, setTotalStudents] = useState(0)

    const [allMongoStudents, setAllMongoStudents] = useState(null)

    const [suggestions, setSuggestions] = useState([]);

    const getAllMongoStudents = async () => {
        setLoadingEntries(true)
        const query = {
            "searchValue": globleSearchValues.map((value) => {
                return value.text
            }),
            "limit": entriesLimit,
            "skip": skipEntries
        }
        const allMongoStdData = await axios.post(serverURL + "/studentMaster/getMongoUsersWithFilter", query)
        if (allMongoStdData.status === 200) {

            console.log(allMongoStdData.data)
            setAllMongoStudents(allMongoStdData.data.students)
            setTotalEntriesCount(allMongoStdData.data.total)
            setLoadingEntries(false)
        } else {
            setLoadingEntries(false)
            console.log(allMongoStdData.data)
        }
    }

    useEffect(() => {
        getAllMongoStudents()

        console.log("Globle Search Values", globleSearchValues)
    }, [skipEntries, entriesLimit, globleSearchValues])


    const { jsonToCSV } = usePapaParse();
    const { CSVDownloader, Type } = useCSVDownloader();

    const [csvDataToExport, setCsvDataToExport] = useState(null)
    const [preparingCSV, setPreparingCSV] = useState(false)




    const handleDelete = (index) => {
        setGlobleSearchValues(globleSearchValues.filter((_, i) => i !== index));
    };

    const onTagUpdate = (index, newTag) => {
        const updatedTags = [...globleSearchValues];
        updatedTags.splice(index, 1, newTag);
        setGlobleSearchValues(updatedTags);
    };

    const handleAddition = (tag) => {
        setGlobleSearchValues((prevTags) => {
            return [...prevTags, tag];
        });
    };

    const handleDrag = (tag, currPos, newPos) => {
        const newTags = globleSearchValues.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);

        // re-render
        setGlobleSearchValues(newTags);
    };

    const handleTagClick = (index) => {
        console.log("The tag at index " + index + " was clicked");
    };

    const onClearAll = () => {
        setGlobleSearchValues([]);
    };


    useEffect(() => {
        socket.on("studentRecordUpdated", () => {
            getAllMongoStudents()
        })

        getAllMongoStudents()
    }, [])


    const exportEmailData = async () => {
        setPreparingCSV(true)
        setCsvDataToExport(null)

        const getAllMails = await axios.post(serverURL + "/studentMaster/getAllMongoStudents")
        if (getAllMails.status === 200) {

            let finalCSVFormat = []

            const allData = getAllMails.data.students

            let labelArrays = []
            Object.keys(allData[0]).map((keynames, key) => {
                return labelArrays.push(keynames)
            })

            let filteredLabels = labelArrays.filter((label) => {
                return (
                    label === "LocCode"
                    ||
                    label === "intakecode"
                    ||
                    label === "StdCode"
                    ||
                    label === "StdName"
                    ||
                    label === "Email"
                    ||
                    label === "Phone"
                    ||
                    label === "DOB"
                    ||
                    label === "RegistrDate"
                    ||
                    label === "ststatus"
                    ||
                    label === "packageCode"
                    ||
                    label === "catCode"
                    ||
                    label === "PaymentStatus"
                    ||
                    label === "stdYgid"
                    ||
                    label === "altygemailid"
                    ||
                    label === "lastMailFetched"
                )
            })

            finalCSVFormat.push(filteredLabels)

            allData.map((message, key) => {
                let currentData = []
                filteredLabels.map((label, key) => {
                    if (label === "lastMailFetched") {
                        if (dayjs(message[label]).isValid()) {
                            currentData.push(dayjs(message[label]).format("DD MMM YYYY, h:mma"))
                        } else {
                            currentData.push(message[label])
                        }
                    }
                    else if (label === "RegistrDate" || label === "DOB") {
                        if (dayjs(message[label]).isValid()) {
                            currentData.push(dayjs(message[label]).format("DD MMM YYYY"))
                        } else {
                            currentData.push(message[label])
                        }
                    }
                    else {
                        currentData.push(message[label])
                    }
                })
                finalCSVFormat.push(currentData)
            })

            setCsvDataToExport(finalCSVFormat)


            const blob = new Blob([jsonToCSV(finalCSVFormat)], { type: 'text/csv' });

            // Create a data URL from the Blob
            const url = URL.createObjectURL(blob);

            // Create a temporary anchor element
            const a = document.createElement('a');
            a.href = url;
            a.download = "StudentBackup " + dayjs().format("DD MMM YYYY HH:mm:ss") + ".csv"; // Set the filename
            a.click();

            setPreparingCSV(false)
            setCsvDataToExport(null)

        } else {
            console.log(getAllMails.data)
            setPreparingCSV(false)
            setCsvDataToExport(null)
        }
    }

    return (
        <>
            <div className="transback h-100 d-flex flex-column p-3">
                <button className='btn text-secondary rounded-pill px-3 py-1 d-flex d-lg-none d-xl-none d-xxl-none align-items-center gap-2' onClick={() => { setShowSideOverlay(true) }}>
                    <MenuIcon />
                </button>
                <div className="headerUserDetails py-1 border-0 d-flex justify-content-between">
                    <span>Student Master</span>
                    <div className='d-flex gap-2 align-items-center justify-content-center text-dark px-2' style={{ cursor: "pointer" }} title={"Name: " + user.name + "\nEmail: " + user.email}>
                        <i className='fa fa-user'></i>
                        <span>{user.name}</span>
                    </div>
                </div>
                <div className='my-3 d-flex gap-2 align-items-start justify-content-between'>
                    <div className='d-flex align-items-center gap-3'>
                        <div className='d-flex align-items-center justify-content-end  rounded-5  p-2'>
                            <ReactTags
                                tags={globleSearchValues}
                                inputFieldPosition="top"
                                suggestions={suggestions}
                                handleDelete={handleDelete}
                                handleAddition={handleAddition}
                                handleDrag={handleDrag}
                                handleTagClick={handleTagClick}
                                onTagUpdate={onTagUpdate}
                                editable
                                clearAll
                                onClearAll={onClearAll}
                                // maxTags={7}
                                allowAdditionFromPaste
                                placeholder='Global Search'
                            />

                            {/* <InputBase
                                sx={{ ml: 1, flex: 1 }}
                                placeholder="Global Search"
                                inputProps={{ 'aria-label': 'Global Search' }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault();
                                        console.log("Enter Pressed")
                                    }
                                }}
                                onInput={(e) => {
                                    setGlobleSearchValues(e.target.value);
                                }}
                            /> */}
                            {/* <IconButton type="button" sx={{ p: '5px' }} aria-label="search">
                                <SearchIcon />
                            </IconButton> */}
                        </div>
                    </div>
                    <div className='btn btn-outline-dark rounded-2 m-0 d-flex' disabled={preparingCSV} onClick={() => { exportEmailData() }}>
                        {
                            preparingCSV ?
                                <div className='d-flex align-items-center gap-1'>
                                    <CustomSpinner size={1} />
                                    Preparing Data
                                </div>
                                :
                                <div className='d-flex align-items-center gap-1'>
                                    <FileDownloadIcon />
                                    CSV
                                </div>

                        }
                    </div>

                </div>
                <div className={`w-100 h-100 overflow-auto d-flex gap-2`}>
                    <div className={`w-100 h-100 overflow-auto d-flex flex-column justify-content-start align-items-start gap-3`}>
                        <table className='table table-yesgermany table-hover'>
                            <thead className='table-dark sticky-top'>
                                <tr align="center">
                                    <th valign="middle" width="1%" className='text-nowrap'>#{totalEntriesCount}</th>
                                    {/* <th valign="middle" width="1%" className='text-nowrap'>timeStamp</th> */}
                                    <th valign="middle" width="1%" className='text-nowrap'>Branch</th>
                                    <th valign="middle" width="1%" className='text-nowrap'>Intake</th>
                                    <th valign="middle" width="1%" className='text-nowrap'>ID</th>
                                    <th valign="middle" width="1%" className='text-nowrap'>Name</th>
                                    <th valign="middle" width="1%" className='text-nowrap'>Personal Email Id</th>
                                    <th valign="middle" width="1%" className='text-nowrap'>Mobile No.</th>
                                    <th valign="middle" width="1%" className='text-nowrap'>Date Of Birth</th>
                                    <th valign="middle" width="1%" className='text-nowrap'>Date Of Registration</th>
                                    <th valign="middle" width="1%" className='text-nowrap'>Status</th>
                                    <th valign="middle" width="1%" className='text-nowrap'>Package</th>
                                    <th valign="middle" width="1%" className='text-nowrap'>Category</th>
                                    <th valign="middle" width="1%" className='text-nowrap'>Paymnet Status</th>
                                    <th valign="middle" width="1%" className='text-nowrap'>Primary YG Email ID</th>
                                    <th valign="middle" width="1%" className='text-nowrap'>Secondary YG Email ID</th>
                                    <th valign="middle" width="1%" className='text-nowrap'>Last Mail Fetched</th>
                                </tr>
                            </thead>
                            <tbody className='table-bordered' >
                                {
                                    allMongoStudents ?
                                        allMongoStudents.length > 0 ?
                                            allMongoStudents.map((data, key) => {
                                                return (
                                                    <tr key={key} align="center">
                                                        <td valign="middle" className='text-nowrap'>{skipEntries + (key + 1)}</td>
                                                        {/* <td valign="middle" className='text-nowrap'>{data.timeStamp}</td> */}
                                                        <td valign="middle" className='text-nowrap'>{data.LocCode}</td>
                                                        <td valign="middle" className='text-nowrap'>{data.intakecode}</td>
                                                        <td valign="middle" className='text-nowrap'>{data.StdCode}</td>
                                                        <td valign="middle" className='text-nowrap'>{data.StdName}</td>
                                                        <td valign="middle" className='text-nowrap'>{data.Email}</td>
                                                        <td valign="middle" className='text-nowrap'>{data.Phone}</td>
                                                        <td valign="middle" className='text-nowrap'>{dayjs(data.DOB).isValid() ? dayjs(data.DOB).format("DD MMM YYYY") : ""}</td>
                                                        <td valign="middle" className='text-nowrap'>{dayjs(data.RegistrDate).isValid() ? dayjs(data.RegistrDate).format("DD MMM YYYY") : ""}</td>
                                                        <td valign="middle" className='text-nowrap'>{data.ststatus}</td>
                                                        <td valign="middle" className='text-nowrap'>{data.packageCode}</td>
                                                        <td valign="middle" className='text-nowrap'>{data.catCode}</td>
                                                        <td valign="middle" className='text-nowrap'>{data.PaymentStatus}</td>
                                                        <td valign="middle" className='text-nowrap'>{data.stdYgid}</td>
                                                        {/* <td valign="middle" className='text-nowrap'>{data.stdygpassword}</td> */}
                                                        <td valign="middle" className='text-nowrap'>{data.altygemailid}</td>
                                                        {/* <td valign="middle" className='text-nowrap'>{data.altygemailpassword}</td> */}
                                                        <td valign="middle" className='text-nowrap'>
                                                            {
                                                                data.lastMailFetched ?
                                                                    data.lastMailFetched !== "Never Synced" ?
                                                                        dayjs(data.lastMailFetched).format("DD MMM YYYY, h:mm:ssa") :
                                                                        "Never Synced"
                                                                    :
                                                                    "Never Synced"
                                                            }
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                            :
                                            <tr>
                                                <td colSpan={15}></td>
                                            </tr>
                                        :
                                        <tr>
                                            <td colSpan={15}></td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className='w-100 mt-2 customBackgroundFilter rounded'>
                    <ConfigProvider
                        theme={{
                            components: {
                                Pagination: {
                                    itemActiveBg: "#faf089",
                                    itemActiveBgDisabled: "yellow",
                                    // itemActiveColorDisabled: "",
                                    // itemBg: "",
                                    // itemInputBg: "",
                                    // itemLinkBg: "",

                                },
                            },
                            token: {
                                // colorBgContainer: "",
                                // colorBgContainerDisabled: "",
                                // colorBgTextActive: "",
                                colorBgTextHover: "rgba(255, 246, 164, 0.73)",
                                // colorBorder: "red",
                                // colorPrimary: "",
                                // colorPrimaryBorder: "#faf089",
                                // colorPrimaryHover: "",
                                // colorText: "",
                                // colorTextDisabled: "",
                                // colorTextPlaceholder: "",
                                // borderRadius: "",
                                // borderRadiusLG: "",
                                // borderRadiusSM: "",
                                // controlHeight: "",
                                // controlOutline: "",
                                // controlOutlineWidth: "",
                                // fontFamily: "",
                                // fontSize: "",
                                // lineHeight: "",
                                margin: 0,
                                // motionDurationMid: "",
                                // paddingXXS: ""
                            }
                        }}
                    >
                        <Pagination defaultCurrent={2} current={currentPageNumber} defaultPageSize={entriesLimit} showSizeChanger={true} showQuickJumper={true} simple={false} disabled={false} total={totalEntriesCount} onChange={(e) => { setCurrentPageNumber(e); setSkipEntries((e - 1) * entriesLimit) }} onShowSizeChange={(page, pageSize) => { setEntriesLimit(pageSize) }} />
                    </ConfigProvider>
                </div>
            </div>
        </>
    )
}

export default StudentMaster